module.exports = __webpack_public_path__ + "img/bar-chart-grouped-dark-01.54040e8d.jpg";